<template>
  <div class="content">
    <div class="container-fluid mt-5 mb-5">
      <h1 class="text-warning text-center">Testimonios y reseñas</h1>
      </br>
      
      <div class="mb-3"></div>

      <div class="row justify-content-around">
        <div class="col-md-3" v-for="(testimonial, idx) in randomTestimonials" :key="testimonial.id">
          <b-card>
            <div class="text-center small">
              <div class="star-rating d-flex justify-content-center mb-3">
                <span v-for="s in testimonial.stars" :key="s" class="star">&#9733;</span>
                <span v-for="s in (5 - testimonial.stars)" :key="'empty-' + s" class="star text-muted">&#9733;</span>
              </div>
              <p>
                {{ testimonial.message }}
              </p>
              <div class="client mt-3">
                — {{ testimonial.client }}
              </div>              
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimoniosComponent',
  data() {
    return {
      testimonials: [
        { id: 1, stars: 5, message: 'Pude constituir mi sociedad en menos tiempo del que creía. La atención al momento de la firma fue muy buena.', client: 'Alan N.'},
        { id: 2, stars: 5, message: 'Mi notificación la hicieron antes del plazo que esperaba. El documento que me entregaron está muy completo.', client: 'Alicia A.'},
        { id: 3, stars: 4, message: 'Antes de usar este sitio no sabía que era un Corredor Público. Me fue muy bien con la constitución de mi empresa. Ojalá tuvieran disponibles más servicios.', client: 'Ángel E.'},
        { id: 4, stars: 5, message: 'Necesitaba una copias certificadas urgentes para un trámite. Todo fue muy fácil y rápido.', client: 'Roberto S.'},
        { id: 5, stars: 5, message: 'Solicité la notificación de un requerimiento de pago. Todo el servicio fue a la distancia a través del sitio de internet. Siempre estuve informado hasta la entrega de mi acta. ¡Felicidades!', client: 'Susana F'},
        { id: 6, stars: 4, message: 'Fue muy fácil constituir mi empresa. Yo creía que era un trámite que me iba a tomar meses, pero a través de este sitio todo fue muy fácil y rápido.', client: 'Paulina C.'},
        { id: 7, stars: 5, message: 'Mandé varios documentos en PDF para certificar. Me dieron cita para recogerlos en 2 días. El día de la entrega llevé mis originales y mi identificación, y todo fue muy rápido.', client: 'Eduardo D.'},
        { id: 8, stars: 5, message: 'Me atoré con la información que tenía que mandar para la constitución de mi empresa. Les llamé y me resolvieron todas mis dudas. Es bueno que haya una persona que pueda resolver las dudas.', client: 'Francisco F.'},
      ]
    };
  },
  computed: {
    randomTestimonials() {
      // Shuffle and pick 3 random testimonials
      const shuffled = this.testimonials
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      return shuffled.slice(0, 3);
    }
  }
};
</script>

<style scoped>
.testimonials {
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;  
}

.testimonial {
  margin-bottom: 0px;
}

.message {
  font-style: italic;
}

.client {
  font-weight: bold;
  text-align: right;
  text-size-adjust: 2em;
}

</style>
